import apiClient from './client';
import { runtime } from '../utils/runtime';

const baseUrl = String(runtime.randomEncountersApiUrl || '/wp-json/pfandpirat/v1/encounters').replace(/\/$/, '');

export function encounterPositionPayload(position) {
  return {
    lat: Number(position?.latitude ?? position?.lat),
    lng: Number(position?.longitude ?? position?.lng),
    accuracy: Number(position?.accuracy),
    heading: Number.isFinite(Number(position?.heading)) ? Number(position.heading) : null,
    speed: Number.isFinite(Number(position?.speed)) ? Number(position.speed) : null,
    timestamp: Number(position?.receivedAt ?? position?.timestamp),
  };
}

export function encounterRequestId(prefix = 'encounter') {
  const uuid = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.round(globalThis.performance?.now?.() || 0)}`;
  return `${prefix}-${uuid}`.slice(0, 100);
}

export function heartbeatEncounter(position, debugType = '') {
  return apiClient.post(`${baseUrl}/heartbeat`, { ...encounterPositionPayload(position), ...(debugType ? { debug_type: debugType } : {}) });
}

export function startEncounter(id, position) {
  return apiClient.post(`${baseUrl}/${encodeURIComponent(id)}/start`, encounterPositionPayload(position));
}

export function actOnEncounter(id, action, position, requestId = encounterRequestId(action)) {
  return apiClient.post(`${baseUrl}/${encodeURIComponent(id)}/action`, { ...encounterPositionPayload(position), action, request_id: requestId });
}

export function completeEncounter(id, position, requestId = encounterRequestId('complete')) {
  return apiClient.post(`${baseUrl}/${encodeURIComponent(id)}/complete`, { ...encounterPositionPayload(position), request_id: requestId });
}

export function relocateEncounter(id, position, requestId = encounterRequestId('relocate')) {
  return apiClient.post(`${baseUrl}/${encodeURIComponent(id)}/relocate`, { ...encounterPositionPayload(position), reason: 'user_unreachable', request_id: requestId });
}
